import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export const WorkoutWrapper = styled(Flex).attrs({
  column: true,
  padding: '15px',
  spacing: 15,
})`
  width: 80%;

  & > div {
    margin: 0;
  }

  @media print {
    padding: 0;
    margin-top: 30px;
    display: block;

    & > span {
      margin: 0 !important;
    }
  }
`;

export const Empty = styled(Flex).attrs({
  column: true,
  align: 'center',
  justify: 'center',
  spacing: 15,
})`
  text-align: center;
  white-space: pre-line;

  @media print {
    display: none;
  }
`;

export const PrintPage = styled.div`
  display: block;
  @media print {
    break-after: page;
    page-break-inside: avoid;
  }
`;

export const SubHeader = styled.div`
  width: 100%;
  border-top: 1px solid #ededed;

  @media print {
    border: none;
  }
`;
